import React from "react";
import { Select, Option, Tooltip, IconButton } from "@mui/joy";
import { Switch } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import styles from "./phoneinbound.module.css";

const pad = (n : number) => (n < 10 ? "0" + n : String(n));

export const formatDuration = (sec : number) => {
    const s = Math.max(0, Math.floor(sec));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return h > 0 ? `${h}:${pad(m)}:${pad(r)}` : `${pad(m)}:${pad(r)}`;
};

//수신자 한 줄: [우선순위] 이름 / 상태 뱃지 / 우선순위 셀렉트 / 수신 토글 / 상세
const ReceiverRow : React.FC<any> = (props) => {

    const r = props.receiver;
    const enabled = r.enabled === 1 || r.enabled === true;
    //서버가 준 busySeconds에 수신 후 경과 시간을 더해서 로컬 카운트업 (클라이언트 시계 차이 영향 없음)
    const busySeconds = (r.busySeconds || 0) + Math.floor((props.now - (r._receivedAt || props.now)) / 1000);

    const renderStatus = () => {
        if (!enabled) {
            return <span className={styles.statusNone}>—</span>;
        }
        if (!props.pbxConnected) {
            return <span className={styles.statusNone} title="교환기 미연결">—</span>;
        }
        switch (r.liveStatus) {
            case "available":
                return <span className={`${styles.statusBadge} ${styles.statusAvailable}`}><span className={styles.dot} />대기</span>;
            case "busy":
                return <span className={`${styles.statusBadge} ${styles.statusBusy}`}><span className={styles.dot} />통화중 {formatDuration(busySeconds)}</span>;
            case "offline":
                return <span className={`${styles.statusBadge} ${styles.statusOffline}`}><span className={styles.dot} />폰 꺼짐</span>;
            case "paused":
                return <span className={`${styles.statusBadge} ${styles.statusPaused}`}><span className={styles.dot} />수신 안 함</span>;
            default:
                return <span className={styles.statusNone}>—</span>;
        }
    };

    const badgeClass = r.priority === 2 ? styles.priorityBadge2 : r.priority === 3 ? styles.priorityBadge3 : "";

    return (
        <div data-flip-id={String(r.id)} className={`${styles.row} ${!enabled ? styles.rowOff : ""}`}>
            <div className={`${styles.priorityBadge} ${badgeClass}`}>{r.priority}</div>
            <div className={styles.nameCol}>
                <span className={styles.name}>{r.name}</span>
                {
                    r.receiverType === "branch" ?
                        <span className={styles.sub}>· {props.queueName || r.branchQueue} 큐</span>
                        :
                        ""
                }
                <span className={styles.ext}>{r.extension}</span>
                {
                    r.desynced ?
                        <Tooltip title={`교환기 설정과 다릅니다: ${(r.desyncReasons || []).join(" / ")}`} variant="soft" color="warning">
                            <WarningAmberRoundedIcon className={styles.desyncIcon} />
                        </Tooltip>
                        :
                        ""
                }
            </div>
            <div className={styles.statusCol}>
                {renderStatus()}
            </div>
            <div>
                <Select
                    size="sm"
                    value={String(r.priority)}
                    disabled={!enabled || props.busy}
                    onChange={(e : any, v : any) => {
                        if (v !== null && +v !== r.priority) {
                            props.onPriority(+v);
                        }
                    }}
                >
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                </Select>
            </div>
            <div>
                <Switch
                    size="small"
                    checked={enabled}
                    disabled={props.busy}
                    onChange={(e) => props.onToggle(e.target.checked)}
                />
            </div>
            <div>
                <IconButton size="sm" variant="plain" color="neutral" onClick={props.onOpenDetail}>
                    <MoreHorizIcon />
                </IconButton>
            </div>
        </div>
    );
};

export default ReceiverRow;
